import { useAppSelector } from "../../../../stateManagement/hooks/redux"
import SmallLoader from "../../../loaders/SmallLoader"
import RosreestrObjectsGroupsListItem from "./RosreestrObjectsCategoriesListItem"

export default function MapRosreestrWidget() {

    const { rosreestrObjectsInfoIsLoading, numberOfSelectedRosreestrObjects, selectedRosreestrObjectsByGroupId } = useAppSelector(state => state.rosreestr)

    return (
        <div className="rosreestr-widget-div">
            {rosreestrObjectsInfoIsLoading
                ?
                <SmallLoader text="Производится поиск объектов Росреестра..." iconColor="black" />
                :
                <div className="rosreestr-objects-groups-list-div">
                    <span>Найдено объектов: {numberOfSelectedRosreestrObjects}</span>
                    <div className="rosreestr-objects-groups-list">
                        {Object.entries(selectedRosreestrObjectsByGroupId).map(([groupId, selectedRosreestrObjectsByCategoryId]: any) => {
                            return (
                                <RosreestrObjectsGroupsListItem
                                    groupId={groupId}
                                    selectedRosreestrObjectsByCategoryId={selectedRosreestrObjectsByCategoryId}
                                />
                            )
                        })}
                    </div>
                </div>
            }
        </div>
    )
}